export const SET_FILTER = 'FAVORITES/SET_FILTER';
export const RESET_FILTERS = 'FAVORITES/RESET_FILTERS';

export const FETCH_PRODUCTS_BEGIN = 'FAVORITES/FETCH_PRODUCTS_BEGIN';
export const FETCH_PRODUCTS_SUCCESS = 'FAVORITES/FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_ERROR = 'FAVORITES/FETCH_PRODUCTS_ERROR';